import React, { useEffect, useState } from "react";
import Loading from "../components/Loading";
import { MdCancel, MdCheck } from "react-icons/md";
import PaginationControls from "../components/PaginationControls";
import SearchBar from "../components/SearchBar";

function SummaryPage() {
    const [page, setPage] = useState(1);
    const [responsesPerPage] = useState(20);
    const [paginatedResponses, setPaginatedResponses] = useState([]);
    const [summary, setSummary] = useState(null);
    const [responses, setResponses] = useState([]);
    const [searchedResponses, setSearchedResponses] = useState([]);
    const [sortedResponses, setSortedResponses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");

    const giorni = ["Lunedi", "Martedi", "Mercoledi", "Giovedi", "Venerdi"];

    useEffect(() => {
        fetch("https://googleform.kmsolution.link/api/get_responses.php")
            .then((response) => response.json())
            .then((data) => {
                if (data.status === "success") {
                    setSummary(data.summary);
                    console.log(data);
                    setResponses(data.responses);
                } else {
                    throw new Error("Errore nel caricamento dei dati");
                }
            })
            .catch((err) => setError(err.message))
            .finally(() => setLoading(false));
    }, []);

    // Filtra le risposte in base al termine di ricerca
    useEffect(() => {
        if (responses) {
            if (searchTerm === "") {
                setSearchedResponses(responses);
            } else {
                setPage(1);
                const searched = responses.filter((response) => {
                    const search = searchTerm.toLowerCase();
                    return (
                        response.nome.toLowerCase().includes(search) ||
                        response.cognome.toLowerCase().includes(search) ||
                        response.classe.toLowerCase().includes(search)
                    );
                });
                setSearchedResponses(searched);
            }
        }
    }, [responses, searchTerm]);

    // Ordina le risposte in base alla classe e al cognome
    useEffect(() => {
        const sorted = [...searchedResponses].sort((a, b) => {
            if (a.classe.trim() < b.classe.trim()) return -1;
            if (a.classe.trim() > b.classe.trim()) return 1;
            if (a.cognome.trim().toLowerCase() < b.cognome.trim().toLowerCase()) return -1;
            if (a.cognome.trim().toLowerCase() > b.cognome.trim().toLowerCase()) return 1;
            return 0;
        });
        setSortedResponses(sorted);
    }, [searchedResponses]);

    // Calcola la paginazione in base alle risposte ordinate
    useEffect(() => {
        const indexOfLastResponse = page * responsesPerPage;
        const indexOfFirstResponse = indexOfLastResponse - responsesPerPage;
        setPaginatedResponses(sortedResponses.slice(indexOfFirstResponse, indexOfLastResponse));
    }, [page, sortedResponses, responsesPerPage]);

    if (loading) return <Loading />;
    if (error) return <p>Errore: {error}</p>;

    return (
        <div className="container my-10">
            <h1>Riepilogo e Dettagli delle Iscrizioni</h1>

            <section className="mt-6">
                <h2>Riepilogo Generico</h2>
                <div className="card mt-6">
                    <h3>1° Turno</h3>
                    <table>
                        <thead>
                            <tr>
                                <th>Corso</th>
                                {giorni.map((giorno) => (
                                    <th key={giorno}>{giorno}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {Object.keys(summary.turno_1).map((corso, index) => (
                                <tr key={index}>
                                    <td>{corso}</td>
                                    {giorni.map((giorno) => {
                                        const booked = summary.turno_1[corso][giorno]?.booked || 0;
                                        const limits = summary.turno_1[corso][giorno]?.limits || 0;
                                        return (
                                            <td key={giorno}>
                                                {booked} / {limits}
                                                <span className="ml-2">
                                                    {booked === limits && '❌'/*  : (booked === 0 ? '✅' : '🕒') */}
                                                </span>
                                            </td>
                                        )
                                    })}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="card mt-6">
                    <h3>2° Turno</h3>
                    <table>
                        <thead>
                            <tr>
                                <th>Corso</th>
                                {giorni.map((giorno) => (
                                    <th key={giorno}>{giorno}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {Object.keys(summary.turno_2).map((corso, index) => (
                                <tr key={index}>
                                    <td>{corso}</td>
                                    {giorni.map((giorno) => {
                                        const booked = summary.turno_2[corso][giorno]?.booked || 0;
                                        const limits = summary.turno_2[corso][giorno]?.limits || 0;
                                        return (
                                            <td key={giorno}>
                                                {booked} / {limits}
                                                <span className="ml-2">
                                                    {booked === limits && '❌'/*  : (booked === 0 ? '✅' : '🕒') */}
                                                </span>
                                            </td>
                                        )
                                    })}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </section>

            <section className="mt-10 overflow-x-auto">
                <h2>Dettagli delle Risposte</h2>
                <div className="card overflow-x-auto mt-4">
                    <SearchBar value={searchTerm} placeholder="Cerca per nome, cognome o classe..." onChange={setSearchTerm} />
                    <table className="mt-4">
                        <thead>
                            <tr>
                                <th>Email</th>
                                <th>Nome</th>
                                <th>Cognome</th>
                                <th>Classe</th>
                                <th>1° Turno</th>
                                <th>2° Turno</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedResponses.map((response, index) => (
                                <tr key={index}>
                                    <td>{response.email}</td>
                                    <td>{response.nome}</td>
                                    <td>{response.cognome}</td>
                                    <td>{response.classe}</td>
                                    <td>
                                        {Object.entries(response.turno_1).map(
                                            ([day, course]) => (
                                                <div key={day}>
                                                    {day}: {course ?? "N/A"}
                                                </div>
                                            )
                                        )}
                                    </td>
                                    <td>
                                        {Object.entries(response.turno_2).map(
                                            ([day, course]) => (
                                                <div key={day}>
                                                    {day}: {course ?? "N/A"}
                                                </div>
                                            )
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <PaginationControls
                        page={page}
                        totalPages={Math.ceil(searchedResponses.length / responsesPerPage)}
                        onPageChange={setPage}
                    />
                </div>
            </section>
        </div>
    );
}

export default SummaryPage;
